import React from "react";
import PhoneInput from "../PhoneInput";
import {
  withFormValidation,
  WithFormValidationProps,
} from "./withFormValidation";

interface FormPhoneInputProps extends WithFormValidationProps {
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  width?: string | number;
}

const FormPhoneInput: React.FC<FormPhoneInputProps> = (props) => {
  const { value, ...restProps } = props;
  return <PhoneInput {...restProps} value={String(value || "")} />;
};

export default withFormValidation(FormPhoneInput);
